import theme from 'theme'

const InstanceUncheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2.1001" y="2.1001" width="11.8" height="11.8" rx="3.5" stroke={theme.colors.controlBorder} />
  </svg>
)

export default InstanceUncheckedIcon
